import { Action } from 'redux';
import { Page } from '../../../api/api.types';
import { RatePlanPeriodModel } from '../../../api/pricing/pricing.types';

export const GET_RATE_PLAN_PERIODS = 'GET_RATE_PLAN_PERIODS';

export interface RatePlanPeriodState {
  ratePlanPeriods: RatePlanPeriodModel[];
}

export interface GetRatePlanPeriodsAction extends Action {
  type: typeof GET_RATE_PLAN_PERIODS;
  payload: {
    page: Page<RatePlanPeriodModel>;
  };
}

export type RatePlanPeriodActionTypes = GetRatePlanPeriodsAction;
